import { useToast } from '@mezzoforte/forge';
import { useMutation } from '@tanstack/react-query';
import { ContactMessageRequest } from '@/types/ApiRequest';
import { useLegacyApi } from '@/hooks/useLegacyApi';

type ContactMessagesAPIResponse =
  | {
      success: true;
    }
  | {
      success: false;
      message: string;
    };

export const useContactMessage = (onSuccess?: () => void) => {
  const { playToast } = useToast();
  const { apiClient } = useLegacyApi();

  const mutation = useMutation({
    mutationFn: (data: ContactMessageRequest) =>
      apiClient
        .post<ContactMessagesAPIResponse>(`/api/net-auctions/${data.entryId}/contact-messages`, data)
        .then((response) => {
          if (response.data.success) return Promise.resolve(response.data);
          return Promise.reject(response.data);
        }),

    onSuccess: () => {
      playToast('Kiitos viestistäsi!', 'Viesti lähetettiin ilmoittajalle.', {});
      onSuccess?.();
    },
    onError: () => {
      playToast('Viestin lähetys epäonnistui', 'Viestiä ei voitu lähettää ilmoittajalle. Yritä myöhemmin uudelleen.', {
        variant: 'danger',
        closeManually: true,
      });
    },
  });

  return mutation;
};
